var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "responsive-table" }, [
      _c(
        "table",
        { staticClass: "w-full" },
        [
          _vm._m(1),
          _vm._v(" "),
          this.isSearching && this.searchedEvents.length < 1
            ? _c("tr", [
                _c(
                  "td",
                  {
                    staticClass: "text-center font-bold",
                    attrs: { colspan: "5" },
                  },
                  [_vm._v("No search results")]
                ),
              ])
            : _vm._l(_vm.pastEvents, function (event) {
                return _c("event-item", {
                  key: event.id,
                  attrs: { event: event },
                })
              }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex mt-8" }, [
      _c("div", { staticClass: "w-1/2" }, [
        _c(
          "button",
          {
            staticClass: "mt-2",
            class: { "opacity-50 cursor-not-allowed": _vm.currentPage === 1 },
            attrs: { disabled: _vm.currentPage === 1 },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.previous.apply(null, arguments)
              },
            },
          },
          [_vm._v("<< Previous")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-1/2 text-right" }, [
        _c(
          "button",
          {
            staticClass: "mt-2",
            class: {
              "opacity-50 cursor-not-allowed":
                _vm.currentPage === _vm.totalPages,
            },
            attrs: { disabled: _vm.currentPage === _vm.totalPages },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.next.apply(null, arguments)
              },
            },
          },
          [_vm._v("Next >>")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex flex-wrap flex-col md:flex-row" }, [
      _c("div", { staticClass: "w-full md:w-1/2" }, [
        _c("h1", { staticClass: "mt-2 mb-4 md:mb-0 font-sans-bold" }, [
          _vm._v("Past Events"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", [_vm._v("Festival")]),
        _vm._v(" "),
        _c("th", [_vm._v("Start Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }